import { Box, Button, Grid, Stack, Typography, useTheme } from "@mui/material";
import { green } from "@mui/material/colors";
import { Link } from "react-router";

const Landing = () => {
  const theme = useTheme();
  return (
    <Grid
      container
      maxWidth={800}
      alignItems={"center"}
      justifyContent={"center"}
      spacing={8}
      sx={{
        margin: {
          xs: theme.spacing(4, 0),
          md: theme.spacing(12, 0),
        },
      }}
    >
      <Grid size={{ xs: 12, md: 7 }}>
        <Stack gap={1} direction={"column"}>
          <Typography variant={"h2"} color={"primary.contrastText"}>
            Emissions{" "}
            <Box component={"span"} color={green[400]}>
              Reduction
            </Box>{" "}
            Planner
          </Typography>
          <Typography variant={"h5"} color={"primary.contrastText"}>
            Explore how decarbonization solutions impact your emissions
            footprint
          </Typography>
        </Stack>
      </Grid>
      <Grid size={{ xs: 12, md: 5 }}>
        <Stack gap={4} direction={"column"}>
          <Stack
            gap={2}
            direction={"column"}
            sx={{
              backgroundColor: "rgba(0, 66, 104, 0.75)",
              padding: 4,
              borderRadius: 1.5,
            }}
          >
            <Typography variant={"body1"} color={"primary.contrastText"}>
              Get a free emissions reduction report in as little as 10 minutes
            </Typography>
            <Button
              variant={"contained"}
              size={"large"}
              color={"secondary"}
              component={Link}
              to={"/target"}
            >
              Get Started
            </Button>
            <Button
              variant={"contained"}
              color={"secondary"}
              component={Link}
              to={"/guided-tour"}
            >
              Request a guided tour
            </Button>
            <Button
              variant={"outlined"}
              color={"secondary"}
              component={Link}
              to={"/learn-more"}
            >
              Learn more
            </Button>
          </Stack>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default Landing;
